import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Menu, X } from 'lucide-react';
export const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Technologie laser',
    href: '#technology'
  }, {
    name: 'Avant / Après',
    href: '#results'
  }, {
    name: 'Tarifs',
    href: '#pricing'
  }, {
    name: 'FAQ',
    href: '#faq'
  }, {
    name: 'Blog',
    href: '#blog'
  }, {
    name: 'Contact',
    href: '#contact'
  }];
  const Logo = () => <a href="#" className="block cursor-pointer" data-id="element-127">
      <img src="https://cdn.magicpatterns.com/uploads/8UGBnXPL8tFE9Y31LhhwcB/Dispel_Blanc.svg" alt="Dispel Your Tattoo" className="h-16 md:h-16 w-auto" data-id="element-128" />
    </a>;
  return <>
      <motion.nav initial={{
      y: -100
    }} animate={{
      y: 0
    }} transition={{
      duration: 0.8,
      ease: [0.16, 1, 0.3, 1]
    }} className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${isScrolled ? 'bg-brand-dark/95 backdrop-blur-md py-3 border-b border-brand-border/50' : 'bg-gradient-to-b from-brand-darker/70 via-brand-darker/30 to-transparent py-5'}`} data-id="element-129">
        <div className="max-w-[1400px] mx-auto px-6 md:px-12 flex items-center justify-between" data-id="element-130">
          <Logo data-id="element-131" />

          {/* Desktop Nav */}
          <div className="hidden lg:flex items-center space-x-7" data-id="element-132">
            {navLinks.map(link => <a key={link.name} href={link.href} className="text-xs font-medium text-brand-light/80 hover:text-brand-light transition-colors duration-300 uppercase tracking-[0.15em]" data-id="element-133">
                {link.name}
              </a>)}
          </div>

          {/* Desktop CTA */}
          <div className="hidden lg:flex items-center" data-id="element-134">
            <a href="#contact" className="px-6 py-2.5 rounded-full border border-brand-light/30 text-xs font-medium text-brand-light hover:bg-brand-light hover:text-brand-dark transition-all duration-300 uppercase tracking-wider" data-id="element-135">
              Réserver une consultation
            </a>
          </div>

          {/* Mobile Toggle */}
          <button className="lg:hidden text-brand-light" onClick={() => setMobileMenuOpen(!mobileMenuOpen)} data-id="element-136">
            {mobileMenuOpen ? <X size={24} data-id="element-137" /> : <Menu size={24} data-id="element-138" />}
          </button>
        </div>
      </motion.nav>

      {/* Mobile Menu */}
      <AnimatePresence data-id="element-139">
        {mobileMenuOpen && <motion.div initial={{
        opacity: 0,
        y: -20
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: -20
      }} className="fixed inset-0 z-40 bg-brand-darker pt-24 px-6 flex flex-col" data-id="element-140">
            <div className="flex flex-col space-y-6 text-xl font-bold uppercase tracking-widest" data-id="element-141">
              {navLinks.map(link => <a key={link.name} href={link.href} onClick={() => setMobileMenuOpen(false)} className="text-brand-light border-b border-brand-border/30 pb-4" data-id="element-142">
                  {link.name}
                </a>)}
            </div>
            <div className="mt-auto mb-12 flex flex-col space-y-4" data-id="element-143">
              <a href="#contact" className="flex items-center justify-center w-full py-4 rounded-full bg-brand-light text-brand-dark font-bold uppercase tracking-wider" data-id="element-144">
                Réserver une consultation
              </a>
            </div>
          </motion.div>}
      </AnimatePresence>
    </>;
};